import myAxios from '../utils/request.js';
import callback from "../utils/callback.js";

export default {
    // 下载文件
    async downLoadFile (params={}, cb) {
        let res = await myAxios.getJson('/file/singleCheck', params);
        return res.data;
    },

    // 获取IP
    async getIp (params={}, cb) {
        let res = await myAxios.getJson('/userController/getIP', params);
        return res.data;
    },
};